import { Col, Flex, Row } from "antd";
import React from "react";
import PremierPlusBinDTO from "src/models/PremierPlusBinDTO";
import CustomButton from "./CustomButton";
import { StopOutlined } from "@ant-design/icons";
import "./DryingView.css";
import ReconditioningPageStateTable from "./ReconditioningPageStateTable";
import PressureGauge from "./Gauges/PressureGauge";
import MoistureGauge from "./Gauges/MoistureGauge";
import DryingValueGauge from "./Gauges/DryingValueGauge";
import TapestripTable from "./TapestripTable";

interface ReconditioningViewProps{
    binDto: PremierPlusBinDTO | null | undefined;
}

const ReconditioningView : React.FC<ReconditioningViewProps> = ({ binDto }) => {

    return(
    <>
        <ReconditioningPageStateTable binDto={binDto}/>

        <Flex align="center" style={{ width: '100%', paddingRight:'16px' }}>
            <div style={{ flex: 1, minWidth: 0 }}>
                <PressureGauge label={"Static Pressure"} pressure={binDto?.fans?.[0]?.plenumPressure}/>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <MoistureGauge label={"Ind. Moisture"} moisture={binDto?.reconditioningOperation?.lastSampleMcPercent}/>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <MoistureGauge label={"Moist. Avg"} moisture={binDto?.reconditioningOperation?.averageSampleMcPercent}/>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <MoistureGauge label={"Plenum EMC"} moisture={binDto?.reconditioningOperation?.actualPlenumMc}/>
            </div>
            <div style={{ flex: 1, minWidth: 0 }}>
                <DryingValueGauge label={"Drying Value"} dryingValue={binDto?.reconditioningOperation?.dryingValueInAhDiff}/>
            </div>
        </Flex>

        <TapestripTable binDto={binDto} inModal={false} maxTapestrips={50} isReconditioning />

        <Row gutter={16} style={{ padding:'8px', justifyContent: "center" }}>

            <Col>
                <CustomButton
                label={'Sequenced Stop'}
                variant='danger'
                disabled={true}
                />
            </Col>

            <Col>
                <CustomButton
                label={'Stop All'}
                variant='danger'
                icon={<StopOutlined/>}
                disabled={true}
                />
            </Col>

            <Col>
                <CustomButton
                label={'Sample'}
                variant='tertiary'
                disabled={true}
                />
            </Col>

            <Col>
                <CustomButton
                label={'Settings'}
                disabled={true}
                />
            </Col>
        </Row>
    </>
    )
}

export default ReconditioningView;
